import { render } from "./Recipe1Screen.vue?vue&type=template&id=54baf82c&scoped=true"
const script = {}

import "./Recipe1Screen.vue?vue&type=style&index=0&id=54baf82c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54baf82c"]])

export default __exports__